/* eslint-disable */
// tslint:disable
/**
 * Branded Tracking Service
 * REST API for Branded Tracking Service
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    address3?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country_code?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postal_code: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    email?: string;
}
/**
 * The tracking state, shipment details, and branding configuration for a shipment
 * @export
 * @interface BrandedTrackingResponse
 */
export interface BrandedTrackingResponse {
    /**
     * 
     * @type {Tracking}
     * @memberof BrandedTrackingResponse
     */
    tracking: Tracking;
    /**
     * 
     * @type {Branding}
     * @memberof BrandedTrackingResponse
     */
    branding: Branding;
    /**
     * 
     * @type {Shipment}
     * @memberof BrandedTrackingResponse
     */
    shipment: Shipment;
}
/**
 * A Branding resource that has been saved in the Branded Tracking Service
 * @export
 * @interface Branding
 */
export interface Branding {
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    branding_id: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    layout_key: BrandingLayoutKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    return_policy?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    phone?: string;
    /**
     * 
     * @type {BrandingPropertiesPoweredBy}
     * @memberof Branding
     */
    powered_by?: BrandingPropertiesPoweredBy;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    store_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    store_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    logo_type?: BrandingLogoTypeEnum;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Branding
     */
    menu_links?: Array<Link> | null;
    /**
     * 
     * @type {Array<SocialLink>}
     * @memberof Branding
     */
    social_media?: Array<SocialLink> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Branding
     */
    external_links?: Array<Link> | null;
    /**
     * 
     * @type {BrandingPropertiesToggles}
     * @memberof Branding
     */
    toggles?: BrandingPropertiesToggles;
    /**
     * 
     * @type {BrandingPropertiesColors}
     * @memberof Branding
     */
    colors?: BrandingPropertiesColors;
    /**
     * 
     * @type {string}
     * @memberof Branding
     */
    theme_key?: BrandingThemeKeyEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BrandingLayoutKeyEnum {
    Layout00 = 'layout00',
    Layout01 = 'layout01',
    StationLegacy = 'station_legacy'
}
/**
    * @export
    * @enum {string}
    */
export enum BrandingLogoTypeEnum {
    Image = 'image',
    Text = 'text'
}
/**
    * @export
    * @enum {string}
    */
export enum BrandingThemeKeyEnum {
    Light = 'light',
    Dark = 'dark',
    Peach = 'peach',
    Unicorns = 'unicorns'
}

/**
 * 
 * @export
 * @interface BrandingAllOf
 */
export interface BrandingAllOf {
    /**
     * 
     * @type {string}
     * @memberof BrandingAllOf
     */
    branding_id: string;
}
/**
 * A set of common colors, fonts, images, layouts, display configuration options, and design elements that can be applied to consumer experiences such as shipment tracking pages, returns, and status emails.
 * @export
 * @interface BrandingProperties
 */
export interface BrandingProperties {
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    layout_key: BrandingPropertiesLayoutKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    return_policy?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    phone?: string;
    /**
     * 
     * @type {BrandingPropertiesPoweredBy}
     * @memberof BrandingProperties
     */
    powered_by?: BrandingPropertiesPoweredBy;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    store_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    store_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    logo_type?: BrandingPropertiesLogoTypeEnum;
    /**
     * 
     * @type {Array<Link>}
     * @memberof BrandingProperties
     */
    menu_links?: Array<Link> | null;
    /**
     * 
     * @type {Array<SocialLink>}
     * @memberof BrandingProperties
     */
    social_media?: Array<SocialLink> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof BrandingProperties
     */
    external_links?: Array<Link> | null;
    /**
     * 
     * @type {BrandingPropertiesToggles}
     * @memberof BrandingProperties
     */
    toggles?: BrandingPropertiesToggles;
    /**
     * 
     * @type {BrandingPropertiesColors}
     * @memberof BrandingProperties
     */
    colors?: BrandingPropertiesColors;
    /**
     * 
     * @type {string}
     * @memberof BrandingProperties
     */
    theme_key?: BrandingPropertiesThemeKeyEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BrandingPropertiesLayoutKeyEnum {
    Layout00 = 'layout00',
    Layout01 = 'layout01',
    StationLegacy = 'station_legacy'
}
/**
    * @export
    * @enum {string}
    */
export enum BrandingPropertiesLogoTypeEnum {
    Image = 'image',
    Text = 'text'
}
/**
    * @export
    * @enum {string}
    */
export enum BrandingPropertiesThemeKeyEnum {
    Light = 'light',
    Dark = 'dark',
    Peach = 'peach',
    Unicorns = 'unicorns'
}

/**
 * 
 * @export
 * @interface BrandingPropertiesColors
 */
export interface BrandingPropertiesColors {
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesColors
     */
    primary?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesColors
     */
    secondary?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesColors
     */
    tertiary?: string;
}
/**
 * 
 * @export
 * @interface BrandingPropertiesPoweredBy
 */
export interface BrandingPropertiesPoweredBy {
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesPoweredBy
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesPoweredBy
     */
    logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandingPropertiesPoweredBy
     */
    url: string;
}
/**
 * 
 * @export
 * @interface BrandingPropertiesToggles
 */
export interface BrandingPropertiesToggles {
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_custom_colors?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_social_media?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_store_url?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_menu_links?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_return_policy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_email?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_phone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_shipment_details?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_item_images?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_item_options?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_shipment_prices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandingPropertiesToggles
     */
    show_store_address?: boolean;
}
/**
 * A code representing a supported carrier
 * @export
 * @enum {string}
 */
export enum Carrier {
    AccessWorldwide = 'access_worldwide',
    AmazonShipping = 'amazon_shipping',
    AmazonShippingUk = 'amazon_shipping_uk',
    AmazonShippingUs = 'amazon_shipping_us',
    Apc = 'apc',
    ApicodeDpdLocal = 'apicode-dpd-local',
    ApicodeDummyCarrier = 'apicode-dummy-carrier',
    ApicodeNewZealandPostInternational = 'apicode-new-zealand-post-international',
    Aramex = 'aramex',
    Asendia = 'asendia',
    AustraliaPost = 'australia_post',
    BrokersWorldwide = 'brokers_worldwide',
    CanadaPost = 'canada_post',
    Canpar = 'canpar',
    CouriersPlease = 'couriers_please',
    DhlEcommerce = 'dhl_ecommerce',
    DhlExpress = 'dhl_express',
    DhlExpressAustralia = 'dhl_express_australia',
    DhlExpressCanada = 'dhl_express_canada',
    DhlExpressFromShipstation = 'dhl_express_from_shipstation',
    DhlExpressUk = 'dhl_express_uk',
    DhlExpressWorldwide = 'dhl_express_worldwide',
    DhlGlobalMail = 'dhl_global_mail',
    Dpd = 'dpd',
    Dpdwallet = 'dpdwallet',
    Endicia = 'endicia',
    Express1 = 'express_1',
    FastwayAu = 'fastway_au',
    FastwayNz = 'fastway_nz',
    Fedex = 'fedex',
    FedexCanada = 'fedex_canada',
    FedexFromParcelcast = 'fedex_from_parcelcast',
    FedexIntlMailservice = 'fedex_intl_mailservice',
    FedexUk = 'fedex_uk',
    Firstmile = 'firstmile',
    GlobalPost = 'global_post',
    Globegistics = 'globegistics',
    Hermes = 'hermes',
    Hermescorp = 'hermescorp',
    Imex = 'imex',
    InternationalBondedCouriers = 'international_bonded_couriers',
    IntersoftRoyalmail = 'intersoft_royalmail',
    Jet = 'jet',
    LaPosteColissimo = 'la_poste_colissimo',
    LandmarkGlobal = 'landmark_global',
    LandmarkGlobalAu = 'landmark_global_au',
    LandmarkGlobalCa = 'landmark_global_ca',
    LandmarkGlobalUk = 'landmark_global_uk',
    Lso = 'lso',
    NewZealandPostCourierpost = 'new-zealand-post-courierpost',
    Newgistics = 'newgistics',
    OneWorldExpress = 'one_world_express',
    Ontrac = 'ontrac',
    Parcelforce = 'parcelforce',
    ParcelforceWalleted = 'parcelforce_walleted',
    PurolatorCa = 'purolator_ca',
    RoyalMail = 'royal_mail',
    RrDonnelley = 'rr_donnelley',
    Seko = 'seko',
    SekoCa = 'seko_ca',
    SekoUk = 'seko_uk',
    SekoUs = 'seko_us',
    Sendle = 'sendle',
    Ss = 'ss',
    StampsCom = 'stamps_com',
    StampsComWl = 'stamps_com_wl',
    StarTrack = 'star_track',
    Tnt = 'tnt',
    Ups = 'ups',
    Usps = 'usps',
    UpsMailInnovations = 'ups_mail_innovations',
    UpsWalleted = 'ups_walleted'
}

/**
 * A block of custom content provided by the merchant to be included in branded notifications, such as a custom message about shipping delays due to COVID-19
 * @export
 * @interface ContentBlock
 */
export interface ContentBlock {
    /**
     * 
     * @type {string}
     * @memberof ContentBlock
     */
    type: ContentBlockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentBlock
     */
    value: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ContentBlockTypeEnum {
    Alert = 'alert'
}

/**
 * A request to create a new Branding resource
 * @export
 * @interface CreateBrandingRequest
 */
export interface CreateBrandingRequest {
    /**
     * 
     * @type {BrandingProperties}
     * @memberof CreateBrandingRequest
     */
    branding: BrandingProperties;
}
/**
 * The result of a Branding creation request
 * @export
 * @interface CreateBrandingResponse
 */
export interface CreateBrandingResponse {
    /**
     * The unique identifier for the newly-created Branding resource
     * @type {string}
     * @memberof CreateBrandingResponse
     */
    branding_id: string;
}
/**
 * A request to create a new NotificationSetting resource
 * @export
 * @interface CreateNotificationSettingRequest
 */
export interface CreateNotificationSettingRequest {
    /**
     * 
     * @type {NotificationProperties}
     * @memberof CreateNotificationSettingRequest
     */
    notification_setting: NotificationProperties;
}
/**
 * The result of a NotificationSetting creation request
 * @export
 * @interface CreateNotificationSettingResponse
 */
export interface CreateNotificationSettingResponse {
    /**
     * The unique identifier for the newly-created NotificationSetting resource
     * @type {string}
     * @memberof CreateNotificationSettingResponse
     */
    notification_setting_id: string;
}
/**
 * A request to create a new Shipment resource
 * @export
 * @interface CreateShipmentRequest
 */
export interface CreateShipmentRequest {
    /**
     * 
     * @type {ShipmentProperties}
     * @memberof CreateShipmentRequest
     */
    shipment: ShipmentProperties;
}
/**
 * The result of a Shipment creation request
 * @export
 * @interface CreateShipmentResponse
 */
export interface CreateShipmentResponse {
    /**
     * The unique identifier for the newly-created Shipment resource
     * @type {string}
     * @memberof CreateShipmentResponse
     */
    shipment_id: string;
}
/**
 * 
 * @export
 * @interface Currency
 */
export interface Currency {
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    amount?: string;
    /**
     * A three-letter ISO4217 code representing a supported currency
     * @type {string}
     * @memberof Currency
     */
    currency_code?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DeliveryState {
    ShipmentCreated = 'shipment_created',
    DeliveryDateAnnounced = 'delivery_date_announced',
    OutForDelivery = 'out_for_delivery',
    Delivered = 'delivered'
}

/**
 * 
 * @export
 * @interface EmailAddress
 */
export interface EmailAddress {
    /**
     * 
     * @type {string}
     * @memberof EmailAddress
     */
    email_address: string;
}
/**
 * Contains information about an API error
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    error: ErrorResponseBody;
}
/**
 * Describes a particular API error with an error code and a message
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    message: string;
    /**
     * Contains any additonal nested errors
     * @type {Array<ErrorResponseBody>}
     * @memberof ErrorResponseBody
     */
    details?: Array<ErrorResponseBody>;
}
/**
 * Represents a link, including text and optional image
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    text: string;
}
/**
 * A code representing a supported notification channel
 * @export
 * @interface NotificationChannel
 */
export interface NotificationChannel {
    /**
     * 
     * @type {string}
     * @memberof NotificationChannel
     */
    channel_type: NotificationChannelChannelTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationChannelChannelTypeEnum {
    Email = 'email'
}

/**
 * NotificationProperties that contain notification configuration and triggers
 * @export
 * @interface NotificationProperties
 */
export interface NotificationProperties {
    /**
     * 
     * @type {Array<NotificationTrigger>}
     * @memberof NotificationProperties
     */
    triggers: Array<NotificationTrigger>;
    /**
     * 
     * @type {NotificationPropertiesEmailConfig}
     * @memberof NotificationProperties
     */
    email_config?: NotificationPropertiesEmailConfig;
}
/**
 * 
 * @export
 * @interface NotificationPropertiesEmailConfig
 */
export interface NotificationPropertiesEmailConfig {
    /**
     * 
     * @type {Array<ContentBlock>}
     * @memberof NotificationPropertiesEmailConfig
     */
    content_blocks?: Array<ContentBlock>;
    /**
     * 
     * @type {string}
     * @memberof NotificationPropertiesEmailConfig
     */
    reply_to_email?: string;
    /**
     * 
     * @type {Array<EmailAddress>}
     * @memberof NotificationPropertiesEmailConfig
     */
    bcc_emails?: Array<EmailAddress>;
}
/**
 * A notification setting resources that has been saved in the Branded Tracking Service
 * @export
 * @interface NotificationSetting
 */
export interface NotificationSetting {
    /**
     * 
     * @type {string}
     * @memberof NotificationSetting
     */
    notification_setting_id: string;
    /**
     * 
     * @type {Array<NotificationTrigger>}
     * @memberof NotificationSetting
     */
    triggers: Array<NotificationTrigger>;
    /**
     * 
     * @type {NotificationPropertiesEmailConfig}
     * @memberof NotificationSetting
     */
    email_config?: NotificationPropertiesEmailConfig;
}
/**
 * 
 * @export
 * @interface NotificationSettingAllOf
 */
export interface NotificationSettingAllOf {
    /**
     * 
     * @type {string}
     * @memberof NotificationSettingAllOf
     */
    notification_setting_id: string;
}
/**
 * A trigger for a branded notification
 * @export
 * @interface NotificationTrigger
 */
export interface NotificationTrigger {
    /**
     * 
     * @type {DeliveryState}
     * @memberof NotificationTrigger
     */
    state: DeliveryState;
    /**
     * Channels to trigger notifications for this delivery state
     * @type {Array<NotificationChannel>}
     * @memberof NotificationTrigger
     */
    channels: Array<NotificationChannel>;
}
/**
 * A shipment resource that has been saved in the Branded Tracking Service
 * @export
 * @interface Shipment
 */
export interface Shipment {
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    shipment_id: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    tracking_number: string;
    /**
     * 
     * @type {Carrier}
     * @memberof Shipment
     */
    carrier_code: Carrier;
    /**
     * Typically a two or three letter language code, sometimes followed by optional subcodes for regions, etc.  See https://www.rfc-editor.org/rfc/bcp/bcp47.txt
     * @type {string}
     * @memberof Shipment
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    service_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    tracking_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    external_account_id: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    order_number: string;
    /**
     * A three-letter ISO4217 code representing a supported currency
     * @type {string}
     * @memberof Shipment
     */
    currency_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    weight_in_ounces?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    signature_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    confirmation_requirement?: ShipmentConfirmationRequirementEnum;
    /**
     * The date for which the purchased label was scheduled to be shipped
     * @type {string}
     * @memberof Shipment
     */
    shipped_date?: string;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    subtotal_price?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    shipping_and_handling_price?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    total_tax?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    total_discount?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    total_price?: Currency;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    branding_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    notification_setting_id?: string;
    /**
     * 
     * @type {Address}
     * @memberof Shipment
     */
    store_address?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Shipment
     */
    destination: Address;
    /**
     * Details about the items in the shipment
     * @type {Array<ShipmentItem>}
     * @memberof Shipment
     */
    line_items?: Array<ShipmentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum ShipmentConfirmationRequirementEnum {
    Adult = 'adult',
    Signature = 'signature',
    Delivery = 'delivery',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface ShipmentAllOf
 */
export interface ShipmentAllOf {
    /**
     * 
     * @type {string}
     * @memberof ShipmentAllOf
     */
    shipment_id: string;
}
/**
 * Represents a line-item product in a Shipment
 * @export
 * @interface ShipmentItem
 */
export interface ShipmentItem {
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    unit_price_cents?: number;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentItem
     */
    unit_price?: Currency;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    subtotal_cents?: number;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentItem
     */
    subtotal_price?: Currency;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    product_name?: string;
    /**
     * 
     * @type {ShipmentItemImages}
     * @memberof ShipmentItem
     */
    image_urls?: ShipmentItemImages;
    /**
     * 
     * @type {Array<ShipmentItemOption>}
     * @memberof ShipmentItem
     */
    options?: Array<ShipmentItemOption>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    description?: string;
}
/**
 * Links to product images for a ShipmentItem
 * @export
 * @interface ShipmentItemImages
 */
export interface ShipmentItemImages {
    /**
     * 
     * @type {string}
     * @memberof ShipmentItemImages
     */
    original: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItemImages
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItemImages
     */
    thumb?: string;
}
/**
 * A key/value pair for custom shipment item options
 * @export
 * @interface ShipmentItemOption
 */
export interface ShipmentItemOption {
    /**
     * 
     * @type {string}
     * @memberof ShipmentItemOption
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItemOption
     */
    value: string;
}
/**
 * A shipment that includes a tracking number and carrier information
 * @export
 * @interface ShipmentProperties
 */
export interface ShipmentProperties {
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    tracking_number: string;
    /**
     * 
     * @type {Carrier}
     * @memberof ShipmentProperties
     */
    carrier_code: Carrier;
    /**
     * Typically a two or three letter language code, sometimes followed by optional subcodes for regions, etc.  See https://www.rfc-editor.org/rfc/bcp/bcp47.txt
     * @type {string}
     * @memberof ShipmentProperties
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    service_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    tracking_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    external_account_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    order_number: string;
    /**
     * A three-letter ISO4217 code representing a supported currency
     * @type {string}
     * @memberof ShipmentProperties
     */
    currency_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    weight_in_ounces?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentProperties
     */
    signature_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    confirmation_requirement?: ShipmentPropertiesConfirmationRequirementEnum;
    /**
     * The date for which the purchased label was scheduled to be shipped
     * @type {string}
     * @memberof ShipmentProperties
     */
    shipped_date?: string;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentProperties
     */
    subtotal_price?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentProperties
     */
    shipping_and_handling_price?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentProperties
     */
    total_tax?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentProperties
     */
    total_discount?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ShipmentProperties
     */
    total_price?: Currency;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    branding_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProperties
     */
    notification_setting_id?: string;
    /**
     * 
     * @type {Address}
     * @memberof ShipmentProperties
     */
    store_address?: Address;
    /**
     * 
     * @type {Address}
     * @memberof ShipmentProperties
     */
    destination: Address;
    /**
     * Details about the items in the shipment
     * @type {Array<ShipmentItem>}
     * @memberof ShipmentProperties
     */
    line_items?: Array<ShipmentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum ShipmentPropertiesConfirmationRequirementEnum {
    Adult = 'adult',
    Signature = 'signature',
    Delivery = 'delivery',
    Null = 'null'
}

/**
 * A link to a supported social media profile
 * @export
 * @interface SocialLink
 */
export interface SocialLink {
    /**
     * 
     * @type {string}
     * @memberof SocialLink
     */
    type: SocialLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialLink
     */
    url: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SocialLinkTypeEnum {
    Twitter = 'twitter',
    Instagram = 'instagram',
    Youtube = 'youtube',
    Pinterest = 'pinterest',
    Facebook = 'facebook',
    Linkedin = 'linkedin'
}

/**
 * Shipment tracking information
 * @export
 * @interface Tracking
 */
export interface Tracking {
    [key: string]: object | any;

    /**
     * The carrier-provided tracking number used to identify a shipment
     * @type {string}
     * @memberof Tracking
     */
    tracking_number: string;
    /**
     * A normalized status code
     * @type {string}
     * @memberof Tracking
     */
    status_code?: TrackingStatusCodeEnum;
    /**
     * A friendly description of the normalized status code
     * @type {string}
     * @memberof Tracking
     */
    status_description?: string;
    /**
     * A carrier-specific status code
     * @type {string}
     * @memberof Tracking
     */
    carrier_status_code?: string;
    /**
     * A carrier-specific status description
     * @type {string}
     * @memberof Tracking
     */
    carrier_status_description?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    ship_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    estimated_delivery_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    actual_delivery_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    exception_description?: string | null;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof Tracking
     */
    events?: Array<TrackingEvent>;
}

/**
    * @export
    * @enum {string}
    */
export enum TrackingStatusCodeEnum {
    AC = 'AC',
    IT = 'IT',
    DE = 'DE',
    EX = 'EX',
    UN = 'UN',
    AT = 'AT',
    NY = 'NY'
}

/**
 * Shipment tracking information
 * @export
 * @interface TrackingEvent
 */
export interface TrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    occurred_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    carrier_occurred_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    city_locality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    state_province?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    postal_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    country_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    company_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    signer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    event_code?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackingEvent
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingEvent
     */
    longitude?: number | null;
}
/**
 * A request to update the properties of an existing Branding resource, or create a new one if none exists with the specified branding_id
 * @export
 * @interface UpdateBrandingRequest
 */
export interface UpdateBrandingRequest {
    /**
     * 
     * @type {BrandingProperties}
     * @memberof UpdateBrandingRequest
     */
    branding: BrandingProperties;
}
/**
 * The result of an UpdateBrandingRequest
 * @export
 * @interface UpdateBrandingResponse
 */
export interface UpdateBrandingResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrandingResponse
     */
    branding_id: string;
}
/**
 * A request to update the properties of an existing Notification Settings resource
 * @export
 * @interface UpdateNotificationSettingRequest
 */
export interface UpdateNotificationSettingRequest {
    /**
     * 
     * @type {NotificationProperties}
     * @memberof UpdateNotificationSettingRequest
     */
    notification_setting: NotificationProperties;
}
/**
 * The result of an UpdateNotificationSettingRequest
 * @export
 * @interface UpdateNotificationSettingResponse
 */
export interface UpdateNotificationSettingResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationSettingResponse
     */
    notification_setting_id: string;
}
/**
 * A request to update the properties of an existing Shipment resource
 * @export
 * @interface UpdateShipmentRequest
 */
export interface UpdateShipmentRequest {
    /**
     * 
     * @type {ShipmentProperties}
     * @memberof UpdateShipmentRequest
     */
    shipment: ShipmentProperties;
}
/**
 * The result of an UpdateShipmentRequest
 * @export
 * @interface UpdateShipmentResponse
 */
export interface UpdateShipmentResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateShipmentResponse
     */
    shipment_id: string;
}

/**
 * BrandingApi - axios parameter creator
 * @export
 */
export const BrandingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new Branding resource
         * @summary Create Branding
         * @param {CreateBrandingRequest} [createBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBranding: async (createBrandingRequest?: CreateBrandingRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/branding`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createBrandingRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createBrandingRequest !== undefined ? createBrandingRequest : {}) : (createBrandingRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an existing Branding resource
         * @summary Get Branding
         * @param {string} brandingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding: async (brandingId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandingId' is not null or undefined
            if (brandingId === null || brandingId === undefined) {
                throw new RequiredError('brandingId','Required parameter brandingId was null or undefined when calling getBranding.');
            }
            const localVarPath = `/branding/{branding_id}`
                .replace(`{${"branding_id"}}`, encodeURIComponent(String(brandingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing Branding resource, or creates a new one with the specified branding_id if one does not exist
         * @summary Update Branding
         * @param {string} brandingId 
         * @param {UpdateBrandingRequest} [updateBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBranding: async (brandingId: string, updateBrandingRequest?: UpdateBrandingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandingId' is not null or undefined
            if (brandingId === null || brandingId === undefined) {
                throw new RequiredError('brandingId','Required parameter brandingId was null or undefined when calling updateBranding.');
            }
            const localVarPath = `/branding/{branding_id}`
                .replace(`{${"branding_id"}}`, encodeURIComponent(String(brandingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateBrandingRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateBrandingRequest !== undefined ? updateBrandingRequest : {}) : (updateBrandingRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandingApi - functional programming interface
 * @export
 */
export const BrandingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new Branding resource
         * @summary Create Branding
         * @param {CreateBrandingRequest} [createBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBranding(createBrandingRequest?: CreateBrandingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBrandingResponse>> {
            const localVarAxiosArgs = await BrandingApiAxiosParamCreator(configuration).createBranding(createBrandingRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve an existing Branding resource
         * @summary Get Branding
         * @param {string} brandingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranding(brandingId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await BrandingApiAxiosParamCreator(configuration).getBranding(brandingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates an existing Branding resource, or creates a new one with the specified branding_id if one does not exist
         * @summary Update Branding
         * @param {string} brandingId 
         * @param {UpdateBrandingRequest} [updateBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBranding(brandingId: string, updateBrandingRequest?: UpdateBrandingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBrandingResponse>> {
            const localVarAxiosArgs = await BrandingApiAxiosParamCreator(configuration).updateBranding(brandingId, updateBrandingRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BrandingApi - factory interface
 * @export
 */
export const BrandingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a new Branding resource
         * @summary Create Branding
         * @param {CreateBrandingRequest} [createBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBranding(createBrandingRequest?: CreateBrandingRequest, options?: any): AxiosPromise<CreateBrandingResponse> {
            return BrandingApiFp(configuration).createBranding(createBrandingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an existing Branding resource
         * @summary Get Branding
         * @param {string} brandingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding(brandingId: string, options?: any): AxiosPromise<Branding> {
            return BrandingApiFp(configuration).getBranding(brandingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing Branding resource, or creates a new one with the specified branding_id if one does not exist
         * @summary Update Branding
         * @param {string} brandingId 
         * @param {UpdateBrandingRequest} [updateBrandingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBranding(brandingId: string, updateBrandingRequest?: UpdateBrandingRequest, options?: any): AxiosPromise<UpdateBrandingResponse> {
            return BrandingApiFp(configuration).updateBranding(brandingId, updateBrandingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandingApi - object-oriented interface
 * @export
 * @class BrandingApi
 * @extends {BaseAPI}
 */
export class BrandingApi extends BaseAPI {
    /**
     * Creates a new Branding resource
     * @summary Create Branding
     * @param {CreateBrandingRequest} [createBrandingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public createBranding(createBrandingRequest?: CreateBrandingRequest, options?: any) {
        return BrandingApiFp(this.configuration).createBranding(createBrandingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an existing Branding resource
     * @summary Get Branding
     * @param {string} brandingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getBranding(brandingId: string, options?: any) {
        return BrandingApiFp(this.configuration).getBranding(brandingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing Branding resource, or creates a new one with the specified branding_id if one does not exist
     * @summary Update Branding
     * @param {string} brandingId 
     * @param {UpdateBrandingRequest} [updateBrandingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public updateBranding(brandingId: string, updateBrandingRequest?: UpdateBrandingRequest, options?: any) {
        return BrandingApiFp(this.configuration).updateBranding(brandingId, updateBrandingRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificationSettingApi - axios parameter creator
 * @export
 */
export const NotificationSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new NotificationSetting resource
         * @summary Create NotificationSetting
         * @param {CreateNotificationSettingRequest} [createNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationSetting: async (createNotificationSettingRequest?: CreateNotificationSettingRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification_setting`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createNotificationSettingRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createNotificationSettingRequest !== undefined ? createNotificationSettingRequest : {}) : (createNotificationSettingRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an existing NotificationSetting resource
         * @summary Get NotificationSetting
         * @param {string} notificationSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSetting: async (notificationSettingId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationSettingId' is not null or undefined
            if (notificationSettingId === null || notificationSettingId === undefined) {
                throw new RequiredError('notificationSettingId','Required parameter notificationSettingId was null or undefined when calling getNotificationSetting.');
            }
            const localVarPath = `/notification_setting/{notification_setting_id}`
                .replace(`{${"notification_setting_id"}}`, encodeURIComponent(String(notificationSettingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing Notification resource
         * @summary Update NotificationSetting
         * @param {string} notificationSettingId 
         * @param {UpdateNotificationSettingRequest} [updateNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationSetting: async (notificationSettingId: string, updateNotificationSettingRequest?: UpdateNotificationSettingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationSettingId' is not null or undefined
            if (notificationSettingId === null || notificationSettingId === undefined) {
                throw new RequiredError('notificationSettingId','Required parameter notificationSettingId was null or undefined when calling updateNotificationSetting.');
            }
            const localVarPath = `/notification_setting/{notification_setting_id}`
                .replace(`{${"notification_setting_id"}}`, encodeURIComponent(String(notificationSettingId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateNotificationSettingRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateNotificationSettingRequest !== undefined ? updateNotificationSettingRequest : {}) : (updateNotificationSettingRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationSettingApi - functional programming interface
 * @export
 */
export const NotificationSettingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new NotificationSetting resource
         * @summary Create NotificationSetting
         * @param {CreateNotificationSettingRequest} [createNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotificationSetting(createNotificationSettingRequest?: CreateNotificationSettingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateNotificationSettingResponse>> {
            const localVarAxiosArgs = await NotificationSettingApiAxiosParamCreator(configuration).createNotificationSetting(createNotificationSettingRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve an existing NotificationSetting resource
         * @summary Get NotificationSetting
         * @param {string} notificationSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationSetting(notificationSettingId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSetting>> {
            const localVarAxiosArgs = await NotificationSettingApiAxiosParamCreator(configuration).getNotificationSetting(notificationSettingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates an existing Notification resource
         * @summary Update NotificationSetting
         * @param {string} notificationSettingId 
         * @param {UpdateNotificationSettingRequest} [updateNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationSetting(notificationSettingId: string, updateNotificationSettingRequest?: UpdateNotificationSettingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNotificationSettingResponse>> {
            const localVarAxiosArgs = await NotificationSettingApiAxiosParamCreator(configuration).updateNotificationSetting(notificationSettingId, updateNotificationSettingRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationSettingApi - factory interface
 * @export
 */
export const NotificationSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a new NotificationSetting resource
         * @summary Create NotificationSetting
         * @param {CreateNotificationSettingRequest} [createNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationSetting(createNotificationSettingRequest?: CreateNotificationSettingRequest, options?: any): AxiosPromise<CreateNotificationSettingResponse> {
            return NotificationSettingApiFp(configuration).createNotificationSetting(createNotificationSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an existing NotificationSetting resource
         * @summary Get NotificationSetting
         * @param {string} notificationSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSetting(notificationSettingId: string, options?: any): AxiosPromise<NotificationSetting> {
            return NotificationSettingApiFp(configuration).getNotificationSetting(notificationSettingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing Notification resource
         * @summary Update NotificationSetting
         * @param {string} notificationSettingId 
         * @param {UpdateNotificationSettingRequest} [updateNotificationSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationSetting(notificationSettingId: string, updateNotificationSettingRequest?: UpdateNotificationSettingRequest, options?: any): AxiosPromise<UpdateNotificationSettingResponse> {
            return NotificationSettingApiFp(configuration).updateNotificationSetting(notificationSettingId, updateNotificationSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationSettingApi - object-oriented interface
 * @export
 * @class NotificationSettingApi
 * @extends {BaseAPI}
 */
export class NotificationSettingApi extends BaseAPI {
    /**
     * Creates a new NotificationSetting resource
     * @summary Create NotificationSetting
     * @param {CreateNotificationSettingRequest} [createNotificationSettingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSettingApi
     */
    public createNotificationSetting(createNotificationSettingRequest?: CreateNotificationSettingRequest, options?: any) {
        return NotificationSettingApiFp(this.configuration).createNotificationSetting(createNotificationSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an existing NotificationSetting resource
     * @summary Get NotificationSetting
     * @param {string} notificationSettingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSettingApi
     */
    public getNotificationSetting(notificationSettingId: string, options?: any) {
        return NotificationSettingApiFp(this.configuration).getNotificationSetting(notificationSettingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing Notification resource
     * @summary Update NotificationSetting
     * @param {string} notificationSettingId 
     * @param {UpdateNotificationSettingRequest} [updateNotificationSettingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSettingApi
     */
    public updateNotificationSetting(notificationSettingId: string, updateNotificationSettingRequest?: UpdateNotificationSettingRequest, options?: any) {
        return NotificationSettingApiFp(this.configuration).updateNotificationSetting(notificationSettingId, updateNotificationSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
export const ShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new Shipment resource
         * @summary Create Shipment
         * @param {CreateShipmentRequest} createShipmentRequest The Shipment to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipment: async (createShipmentRequest: CreateShipmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShipmentRequest' is not null or undefined
            if (createShipmentRequest === null || createShipmentRequest === undefined) {
                throw new RequiredError('createShipmentRequest','Required parameter createShipmentRequest was null or undefined when calling createShipment.');
            }
            const localVarPath = `/shipment`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createShipmentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createShipmentRequest !== undefined ? createShipmentRequest : {}) : (createShipmentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an existing Shipment resource
         * @summary Get Shipment
         * @param {string} shipmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipment: async (shipmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            if (shipmentId === null || shipmentId === undefined) {
                throw new RequiredError('shipmentId','Required parameter shipmentId was null or undefined when calling getShipment.');
            }
            const localVarPath = `/shipment/{shipment_id}`
                .replace(`{${"shipment_id"}}`, encodeURIComponent(String(shipmentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing Shipment resource
         * @summary Update Shipment
         * @param {string} shipmentId 
         * @param {UpdateShipmentRequest} [updateShipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipment: async (shipmentId: string, updateShipmentRequest?: UpdateShipmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            if (shipmentId === null || shipmentId === undefined) {
                throw new RequiredError('shipmentId','Required parameter shipmentId was null or undefined when calling updateShipment.');
            }
            const localVarPath = `/shipment/{shipment_id}`
                .replace(`{${"shipment_id"}}`, encodeURIComponent(String(shipmentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Application-API-Key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("API-Key")
                    : await configuration.apiKey;
                localVarHeaderParameter["API-Key"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateShipmentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateShipmentRequest !== undefined ? updateShipmentRequest : {}) : (updateShipmentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentsApi - functional programming interface
 * @export
 */
export const ShipmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new Shipment resource
         * @summary Create Shipment
         * @param {CreateShipmentRequest} createShipmentRequest The Shipment to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShipment(createShipmentRequest: CreateShipmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateShipmentResponse>> {
            const localVarAxiosArgs = await ShipmentsApiAxiosParamCreator(configuration).createShipment(createShipmentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve an existing Shipment resource
         * @summary Get Shipment
         * @param {string} shipmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipment(shipmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Shipment>> {
            const localVarAxiosArgs = await ShipmentsApiAxiosParamCreator(configuration).getShipment(shipmentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates an existing Shipment resource
         * @summary Update Shipment
         * @param {string} shipmentId 
         * @param {UpdateShipmentRequest} [updateShipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShipment(shipmentId: string, updateShipmentRequest?: UpdateShipmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateShipmentResponse>> {
            const localVarAxiosArgs = await ShipmentsApiAxiosParamCreator(configuration).updateShipment(shipmentId, updateShipmentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ShipmentsApi - factory interface
 * @export
 */
export const ShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a new Shipment resource
         * @summary Create Shipment
         * @param {CreateShipmentRequest} createShipmentRequest The Shipment to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipment(createShipmentRequest: CreateShipmentRequest, options?: any): AxiosPromise<CreateShipmentResponse> {
            return ShipmentsApiFp(configuration).createShipment(createShipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an existing Shipment resource
         * @summary Get Shipment
         * @param {string} shipmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipment(shipmentId: string, options?: any): AxiosPromise<Shipment> {
            return ShipmentsApiFp(configuration).getShipment(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing Shipment resource
         * @summary Update Shipment
         * @param {string} shipmentId 
         * @param {UpdateShipmentRequest} [updateShipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipment(shipmentId: string, updateShipmentRequest?: UpdateShipmentRequest, options?: any): AxiosPromise<UpdateShipmentResponse> {
            return ShipmentsApiFp(configuration).updateShipment(shipmentId, updateShipmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
export class ShipmentsApi extends BaseAPI {
    /**
     * Creates a new Shipment resource
     * @summary Create Shipment
     * @param {CreateShipmentRequest} createShipmentRequest The Shipment to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public createShipment(createShipmentRequest: CreateShipmentRequest, options?: any) {
        return ShipmentsApiFp(this.configuration).createShipment(createShipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an existing Shipment resource
     * @summary Get Shipment
     * @param {string} shipmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipment(shipmentId: string, options?: any) {
        return ShipmentsApiFp(this.configuration).getShipment(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing Shipment resource
     * @summary Update Shipment
     * @param {string} shipmentId 
     * @param {UpdateShipmentRequest} [updateShipmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public updateShipment(shipmentId: string, updateShipmentRequest?: UpdateShipmentRequest, options?: any) {
        return ShipmentsApiFp(this.configuration).updateShipment(shipmentId, updateShipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns tracking, branding, and shipment details for an existing shipment
         * @summary Get Branded Tracking
         * @param {string} brandingId The unique identifier of the Branding to apply
         * @param {string} [shipmentId] The unique id of a Shipment resource to track. If this parameter is not supplied, the remaining Shipment query parameters are required in order to uniquely identify a Shipment.
         * @param {string} [carrierCode] The carrier code of the shipment to track
         * @param {string} [trackingNumber] The tracking number of the shipment to track
         * @param {string} [orderNumber] The order number of the shipment to track
         * @param {string} [postalCode] The destination postal code of the shipment to track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandedTracking: async (brandingId: string, shipmentId?: string, carrierCode?: string, trackingNumber?: string, orderNumber?: string, postalCode?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandingId' is not null or undefined
            if (brandingId === null || brandingId === undefined) {
                throw new RequiredError('brandingId','Required parameter brandingId was null or undefined when calling getBrandedTracking.');
            }
            const localVarPath = `/track`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandingId !== undefined) {
                localVarQueryParameter['branding_id'] = brandingId;
            }

            if (shipmentId !== undefined) {
                localVarQueryParameter['shipment_id'] = shipmentId;
            }

            if (carrierCode !== undefined) {
                localVarQueryParameter['carrier_code'] = carrierCode;
            }

            if (trackingNumber !== undefined) {
                localVarQueryParameter['tracking_number'] = trackingNumber;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns tracking, branding, and shipment details for an existing shipment
         * @summary Get Branded Tracking
         * @param {string} brandingId The unique identifier of the Branding to apply
         * @param {string} [shipmentId] The unique id of a Shipment resource to track. If this parameter is not supplied, the remaining Shipment query parameters are required in order to uniquely identify a Shipment.
         * @param {string} [carrierCode] The carrier code of the shipment to track
         * @param {string} [trackingNumber] The tracking number of the shipment to track
         * @param {string} [orderNumber] The order number of the shipment to track
         * @param {string} [postalCode] The destination postal code of the shipment to track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandedTracking(brandingId: string, shipmentId?: string, carrierCode?: string, trackingNumber?: string, orderNumber?: string, postalCode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandedTrackingResponse>> {
            const localVarAxiosArgs = await TrackingApiAxiosParamCreator(configuration).getBrandedTracking(brandingId, shipmentId, carrierCode, trackingNumber, orderNumber, postalCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns tracking, branding, and shipment details for an existing shipment
         * @summary Get Branded Tracking
         * @param {string} brandingId The unique identifier of the Branding to apply
         * @param {string} [shipmentId] The unique id of a Shipment resource to track. If this parameter is not supplied, the remaining Shipment query parameters are required in order to uniquely identify a Shipment.
         * @param {string} [carrierCode] The carrier code of the shipment to track
         * @param {string} [trackingNumber] The tracking number of the shipment to track
         * @param {string} [orderNumber] The order number of the shipment to track
         * @param {string} [postalCode] The destination postal code of the shipment to track
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandedTracking(brandingId: string, shipmentId?: string, carrierCode?: string, trackingNumber?: string, orderNumber?: string, postalCode?: string, options?: any): AxiosPromise<BrandedTrackingResponse> {
            return TrackingApiFp(configuration).getBrandedTracking(brandingId, shipmentId, carrierCode, trackingNumber, orderNumber, postalCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
    /**
     * Returns tracking, branding, and shipment details for an existing shipment
     * @summary Get Branded Tracking
     * @param {string} brandingId The unique identifier of the Branding to apply
     * @param {string} [shipmentId] The unique id of a Shipment resource to track. If this parameter is not supplied, the remaining Shipment query parameters are required in order to uniquely identify a Shipment.
     * @param {string} [carrierCode] The carrier code of the shipment to track
     * @param {string} [trackingNumber] The tracking number of the shipment to track
     * @param {string} [orderNumber] The order number of the shipment to track
     * @param {string} [postalCode] The destination postal code of the shipment to track
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public getBrandedTracking(brandingId: string, shipmentId?: string, carrierCode?: string, trackingNumber?: string, orderNumber?: string, postalCode?: string, options?: any) {
        return TrackingApiFp(this.configuration).getBrandedTracking(brandingId, shipmentId, carrierCode, trackingNumber, orderNumber, postalCode, options).then((request) => request(this.axios, this.basePath));
    }

}


